export const ROUTE_PATHS = {
  HOME: '/',
  RESULTADO: '/resultado',
};
